export const FETCH_INTERVAL_DAYS = 30;
export const eventNames = {
    DASHBOARD_ACCESS: "DashboardAccess",
    MINIDASHBOARD_ACCESS: "MiniDashboardAccess",
    EMAIL_SENT: "EmailSent",
    ACCOUNT_ACCESS: "AccountAccess"
}